"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndpointUpdatedEventData = void 0;
class EndpointUpdatedEventData {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EndpointUpdatedEventData.attributeTypeMap;
    }
}
exports.EndpointUpdatedEventData = EndpointUpdatedEventData;
EndpointUpdatedEventData.discriminator = undefined;
EndpointUpdatedEventData.attributeTypeMap = [
    {
        "name": "appId",
        "baseName": "appId",
        "type": "string",
        "format": ""
    },
    {
        "name": "appUid",
        "baseName": "appUid",
        "type": "string",
        "format": ""
    },
    {
        "name": "endpointId",
        "baseName": "endpointId",
        "type": "string",
        "format": ""
    },
    {
        "name": "endpointUid",
        "baseName": "endpointUid",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=EndpointUpdatedEventData.js.map